import axiosInstance from "./AxiosConfig";

class ClientSubscritptionApiService {
  async CreateClientSubscription(data) {
    
    const payload = {
      BranchId: data.branchId,
      packageId: data.packageId,
      strt_dt: data.startDate,
      Exp_Dt: data.expiryDate,
      Status: data.status,
    };
    try {
      const response = await axiosInstance.post(
        `/clientsSubscription/create`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetAllClientsSub() {
    try {
      const response = await axiosInstance.get("/clientsSubscription/get");
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateClientsSubscriptionByid(id, data) {
    
    try {
      const response = await axiosInstance.put(
        `/clientsSubscription/update/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteClientsSubscriptionByid(id) {
    try {
      const response = await axiosInstance.delete(
        `/clientsSubscription/delete/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new ClientSubscritptionApiService();
